<template>
  <collapsed-section title="Vet Details" :open="true">
    <labeled-form-control label="Vet Name">
      <input @blur="handleBlur" v-model="name" class="form-control" type="text" placeholder="Enter Vet Name"/>
      <validation-message v-if="validator.name" :message="validator.name"/>
    </labeled-form-control>
    <labeled-form-control label="Mobile">
      <input @blur="handleBlur" v-model="mobile" class="form-control" type="tel" placeholder="Enter Mobile"/>
    </labeled-form-control>
    <labeled-form-control label="Address">
      <textarea
        @blur="handleBlur"
        v-model="otherInfo"
        class="form-control"
        cols="50"
        rows="5"
        maxlength="50"
        placeholder="Enter Address"
      ></textarea>
    </labeled-form-control>
  </collapsed-section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { ContactHelper } from '@/helpers/ContactHelper'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import CollapsedSection from '../Layout/CollapsedSection.vue'
import LabeledFormControl from '../Layout/LabeledFormControl.vue'
import ValidationMessage from '../ErrorValidation/ValidationMessage.vue'

export default {
  name: 'VetContact',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      validator: ContactHelper.getContactValidator()
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapGetters('ClientRegistrationUpload', [
      'findContact'
    ]),
    contactTypeId () {
      return 3
    },
    contact () {
      return this.findContact(this.contactTypeId)
    },
    name: {
      get () {
        return this.contact ? this.contact.name : ''
      },
      set (value) {
        this.setContactName({ contactTypeId: this.contactTypeId, value })
      }
    },
    mobile: {
      get () {
        return this.contact ? this.contact.mobile : ''
      },
      set (value) {
        this.setContactMobile({ contactTypeId: this.contactTypeId, value })
      }
    },
    otherInfo: {
      get () {
        return this.contact?.otherInfo || ''
      },
      set (value) {
        this.setContactOtherInfo({ contactTypeId: this.contactTypeId, value })
      }
    },
    vetContactModel () {
      return {
        name: this.name,
        mobile: this.mobile,
        otherInfo: this.otherInfo
      }
    },
    trimmedName () {
      return (this.name || '').trim()
    },
    trimmedMobile () {
      return (this.mobile || '').trim()
    },
    trimmedOtherInfo () {
      return (this.otherInfo || '').trim()
    },
    hasAnyValue () {
      return !!this.trimmedName || !!this.trimmedMobile || !!this.trimmedOtherInfo
    },
    validated () {
      return !this.hasAnyValue || !!this.trimmedName
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    },
    name () {
      if (this.validator.name) this.validate()
    },
    mobile () {
      if (this.validator.name) this.validate()
    },
    otherInfo () {
      if (this.validator.name) this.validate()
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setContactName',
      'setContactMobile',
      'setContactOtherInfo'
    ]),
    handleBlur () {
      this.validate()
    },
    validate () {
      this.validator.check(this.vetContactModel)
    }
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'validation-message': ValidationMessage
  }
}
</script>
